import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

export enum TransformToUserAction {
  InviteNewUser = 'invite_new_user',
  CreateNewGuardian = 'create_new_guardian',
  SyncWithExistingUser = 'sync_existing_user',
  CreateNewEntity = 'create_new_entity',
  SyncWithExistingEntity = 'sync_existing_entity',
}

@AutoUnsubscribe()
@Component({
  selector: 'transform-to-user-dialog',
  templateUrl: './transform-to-user-dialog.component.html',
  styleUrls: ['./transform-to-user-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransformToUserDialogComponent implements OnInit {
  TransformToUserAction = TransformToUserAction;
  dialogTitle = 'Transform to User';
  transformOptions: Array<any> = [];
  private defaultUserOptions = [
    {
      label: 'Invite New User',
      action: TransformToUserAction.InviteNewUser,
      isSelected: false,
    },
    {
      label: 'Create New Guardian',
      action: TransformToUserAction.CreateNewGuardian,
      isSelected: false,
    },
    {
      label: 'Sync With Existing User',
      action: TransformToUserAction.SyncWithExistingUser,
      isSelected: false,
    },
  ];
  private defaultEntityOptions = [
    {
      label: 'Create New Entity',
      action: TransformToUserAction.CreateNewEntity,
      isSelected: false,
    },
    {
      label: 'Sync With Existing Entity',
      action: TransformToUserAction.SyncWithExistingEntity,
      isSelected: false,
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TransformToUserDialogComponent>,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const mode = this.data?.mode || 'user';
    if (this.data?.dialogTitle) {
      this.dialogTitle = this.data.dialogTitle;
    } else {
      this.dialogTitle = mode === 'entity' ? 'Transform to Legal Entity' : 'Transform to User';
    }
    if (this.data?.transformOptions?.length) {
      this.transformOptions = this.data.transformOptions.map((option) => ({
        ...option,
        isSelected: false,
      }));
    } else {
      const sourceOptions = mode === 'entity' ? this.defaultEntityOptions : this.defaultUserOptions;
      this.transformOptions = sourceOptions.map((option) => ({ ...option }));
    }
  }

  selectOption(item: any) {
    this.transformOptions.forEach((opt) => {
      opt.isSelected = false;
    });
    item.isSelected = true;
    this.cd.detectChanges();

    // Close dialog and return the selected action to parent
    setTimeout(() => {
      this.dialogRef.close({ action: item.action, confirmation: true });
    }, 200);
  }

  closeDialog() {
    this.dialogRef.close({ confirmation: false });
  }
}
